import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=878574aa&scoped=true&"
import script from "./MemberEdit.vue?vue&type=script&lang=js&"
export * from "./MemberEdit.vue?vue&type=script&lang=js&"
import style0 from "./MemberEdit.vue?vue&type=style&index=0&id=878574aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878574aa",
  null
  
)

export default component.exports